import { useTranslations } from 'next-intl';
import ProductCardSkeleton from '@//containers/ProductCardSkeleton';

const SkeletonList = new Array(24).fill(null);

export const SearchResultSkeleton = () => {
  const t = useTranslations('pages.search.results');

  return (
    <>
      <div role="status" aria-live="polite" className="sr-only">
        {t('loading')}
      </div>
      {SkeletonList.map((_, i) => (
        <ProductCardSkeleton key={`skeleton-${i}`} />
      ))}
    </>
  );
};
